export default function PressReleaseEntries() {
  return    (

 <table id="filetable">
  <tr>
    <th>File Name</th>
    <th>Date Posted</th>
  </tr>
   {/*Start File*/}
  <tr>
    <td>
      <a href="../docs/press/press-2026-halloween-policy-20261015165047.pdf" target="_blank" rel="noopener noreferrer">
        <i className="fa-solid fa-file-pdf fa-xl"></i>
        &nbsp; Policy Statement: Halloween Trick-Or-Treat Activity
      </a>
    </td>
    <td>10/17/2026</td>
  </tr>
  {/*End File*/}
  {/*Start File*/}
  <tr>
    <td>
      <a href="../docs/press/press-2025-Off-peak_alternating_single-lane_at_Calhoun_Street_Bridge_next_week.pdf" target="_blank" rel="noopener noreferrer">
        <i className="fa-solid fa-file-pdf fa-xl"></i>
        &nbsp; Alternating Single-lane travel on Calhoun Street Bridge next week
      </a>
    </td>
    <td>4/4/2025</td>
  </tr>
  {/*End File*/}
 
</table>
);
}
